





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { ToneConfig } from './../type/ToneConfig';
import { ToneListConfig, ToneObjConfig } from './../type/ToneListConfig';

// components
import NavTitle from './NavTitle.vue';
import MusicItem from './MusicItem.vue';

@Component({
  components: {
    NavTitle,
    MusicItem
  }
})
export default class Ringtone extends Vue {

  // 預設選取第一個 tab
  inTab: number = 0;
  isMounted: boolean = false

  get toneObj() {
    return this.$store.state.toneObj;
  }

  get tabList() {
    return this.$store.state.toneTab;
  }

  get inTabName(): string {
    return this.tabList[this.inTab];
  }

  get showList() {
    let str: string = this.inTabName;
    let list: ToneConfig[] = this.toneObj[str].map((music: ToneConfig, id: number) => ({
      id,
      ...music
    }));
    return list;
  }

  async mounted() {
    await this.$store.dispatch('GET_TONE');
    this.isMounted = true
  }

  tabSelectHandler(id: number) {
    this.inTab = id;
  }

}
